import React, { useEffect, useState } from "react";
import { Utensils } from "lucide-react";

// Wraps an <img> with a graceful fallback: shows the Utensils placeholder
// when there's no URL at all, or when the URL fails to load (dead link,
// removed stock photo, network hiccup) instead of a broken-image icon.
export function FoodImage({ src, alt, className, iconClassName = "h-8 w-8 text-muted-foreground/20" }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Utensils className={iconClassName} />
      </div>
    );
  }

  return <img src={src} alt={alt} className={className} onError={() => setFailed(true)} />;
}
